import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { tesaBlue, tesaWhite } from "../../styles/colors";
import tesaLogo from "../../assets/images/tesa-logo.svg";
import leapLogo from "../../assets/images/leap-logo.svg";

const useStyles = makeStyles({
  root: {
    color: tesaWhite,
    backgroundColor: tesaBlue,
    position: "fixed",
    height: "100%",
    width: "100%",
    textAlign: "center",
    zIndex: 300,
    "& a": {
      color: tesaWhite,
    },
  },
  content: {
    position: "absolute",
    top: "42%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  headline: {
    textTransform: "uppercase",
    marginBlockEnd: 0,
  },
  message: {
    fontSize: "16px",
    lineHeight: "24px",
  },
  leap: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  logo: {
    position: "absolute",
    left: "40px",
    bottom: "40px",
  },
});

interface AccessDeniedPageProps {
  noNavbar?: boolean;
}

const AccessDeniedPage: React.FC<AccessDeniedPageProps> = (props) => {
  const { noNavbar } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {noNavbar && (
        <div className={classes.leap}>
          <img width={166} src={leapLogo} alt="" />
        </div>
      )}
      <div className={clsx(classes.content, "LEAP-accessDenied-label-container")}>
        <h1 className={classes.headline}>Access denied</h1>
        <div className={classes.message}>
          It seems that you do not have access permissions
          <br /> for the requested page.
          <p>
            In case you need access to the application please request access via{" "}
            <a
              href="https://bssnow.beiersdorfgroup.com/esc?id=sc_cat_item&sys_id=0d41bcf13b6c5e109f94372a85e45a6d"
              target="_blank"
              rel="noopener noreferrer"
            >
              BITS
            </a>
          </p>
        </div>
      </div>
      {noNavbar && (
        <div className={classes.logo}>
          <img width={72} src={tesaLogo} alt="" />
        </div>
      )}
    </div>
  );
};

export default AccessDeniedPage;
